var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6966 8.82092C34.382 9.47179 34.382 10.5271 33.6966 11.1779L12.637 31.1779C11.9517 31.8288 10.8405 31.8288 10.1551 31.1779C9.46977 30.5271 9.46977 29.4718 10.1551 28.8209L31.2147 8.82092C31.9001 8.17005 33.0113 8.17005 33.6966 8.82092Z",
    fill: "#2A2D31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1551 8.82092C10.8405 8.17005 11.9517 8.17005 12.637 8.82092L33.6966 28.8209C34.382 29.4718 34.382 30.5271 33.6966 31.1779C33.0113 31.8288 31.9001 31.8288 31.2147 31.1779L10.1551 11.1779C9.46977 10.5271 9.46977 9.47179 10.1551 8.82092Z",
    fill: "#2A2D31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconBlack);
export default __webpack_public_path__ + "static/media/xIconBlack.1774cf849a672212e20e6c72d5b1bd42.svg";
export { ForwardRef as ReactComponent };